export default __webpack_public_path__ + "static/media/3.11409a4c.wav";